<template>
  <div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>
    
	<app-hero-section :urlBackground="urlBackground" :herotype="herotype">
    <h1 style="color: #fff;" class="fs-48 fs-md-38 fs-sm-38 lh-9 lh-md-7 lh-sm-7 md-3 mb-6 mt-md-5 mt-sm-3 f-anti">Love Venmo? <br/> Sadly it doesn’t work internationally</h1>
    <p class="fs-19 fs-sm-19 fw-medium f-anti lh-4 mb-4 ls-1">Each Venmo transfer needs the sender and beneficiary to be physically in the US, so you can’t use it to send money abroad to a friend or family.</p>

    <p class="fs-19 fs-sm-19 fw-medium f-anti lh-4 ls-1">If you’re looking for the best & <a href="https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=hero_section">cheapest way to send money internationally</a>, you can compare all solutions in real-time with <a href="https://www.monito.com/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=hero_section">Monito’s money transfer comparison tool.</a></p>  
    </app-hero-section>	

	  <app-subhero-section class="pt-20 pb-7 pb-sm-3  mb-4">

      <widget-text-featured-block class="mb-9">
        <div>
          <h2 class="fs-28 fs-md-25 fs-sm-24 lh-6 ls-sm-2 lh-sm-5 mt-5 mb-1 mb-sm-3">Monito is like a travel comparison site, but for money transfers</h2>
          <span class="fs-19 fs-md-17 fs-sm-17 italic fw-demi-bold f-anti" style="opacity: 0.88;">Compare. Select the best provider. Save money</span>
          <a href="https://www.monito.com/en/how-it-works?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=subhero_section" class="f-anti ls-2 mt-5">Learn more</a>
        </div>
        <aside>
          <div class="fs-17 fw-demi-bold f-anti ls-1 lock">We only recommend companies that are secured and regulated</div>
          <div class="fs-17 fw-demi-bold f-anti ls-1 group">Our comparison engine is trusted by 3 million users worldwide</div>
        </aside>
      </widget-text-featured-block>

      <widget-featured-on>
        
        <li><a href="https://www.forbes.com/sites/davidprosser/2017/11/22/europes-10-most-exciting-technology-smes-for-2018/#7ee7841d35e2"><img src="public/forbes_logo.png"></a></li>
        <li><a href="http://guardian.co.uk/"><img src="public/guardian_logo.png"></a></li>
        <li><a href="https://www.businessinsider.com/fintech-uses-data-driven-testing-in-every-aspect-of-business-2020-4?r=US&IR=T"><img src="public/business_insider_logo.png"></a></li>
        <li><a href="https://www.lemonde.fr/"><img src="public/le_monde_logo.png"></a></li>
      </widget-featured-on>

    </app-subhero-section>

  </header>

  <widget-providers :providers="providers">
    <h1 class="fs-28 lh-6 mb-1 mt-5
      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2
    ">Alternatives to Venmo for sending money outside the US</h1>
    <span class="fs-19 italic fs-sm-17 fw-demi-bold f-anti" style="opacity: 0.88;">Read our in-depth review about each provider</span>
  </widget-providers>

  <aside class="scroller mobile" ><monito-widgets-imt-search-form powered-by-nf="off" cta-label="Find alternatives to Venmo" country-from="US" country-to="MX"  utm-source="internal" utm-medium="internal"utm-content="main_content_widget" utm-campaign="ABTestVenmo"></monito-widgets-imt-search-form></aside>

  <main ref="main">
    <section ref="scroll_zone" class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8
      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
        <div class="color"></div>
        <h1 class="f_title mt-3 mb-7 mt-2-sm mb-sm-6">If Venmo isn’t an option, what is?</h1>
        <widget-author class="mb-6">
          <div class="portrait" >
            <span class="image" style="background-image:url('public/pascal.png');"></span>
            <p class="name pt-sm-2"><span>Written by</span><a href="https://www.monito.com/en/wiki/why-you-can-trust-monito#1?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Pascal Briod</a></p>
            <p class="update"><span>Last updated</span>August 22, 2019</p>
          </div>
          <p class="bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti">Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.</p>
        </widget-author>
        <p class="f_body">You can’t send money abroad with Venmo, so your first reflex may be to come back to an old-fashioned « bank transfer ». But not only would this option be less convenient, this would cost you a lot of money as banks usually give you a very bad exchange rate (on top of charging you fees for international transfers).</p>
        <p class="f_body">Fortunately, innovative companies are doing what Venmo did locally in the US, but for international transfers. Via their online platforms or mobile apps, they are offering bank-beating exchange rates, very low fees, and a top-notch user experience. Depending on where you want to send money to, companies like <a href="https://www.monito.com/en/send-money-with/transferwise?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">TransferWise</a>, <a href="https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">WorldRemit</a>, <a href="https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Remitly </a>or <a target="_blank" rel="noopener" href="https://www.monito.com/en/send-money-with/instarem?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">InstaReM</a> will probably be your top choice. </p>
        <h2 class="f_subtitle_1">Why comparing money transfer fees and exchange rates?</h2>
        <p class="f_body">When you send money abroad, you will be charged a transfer fee. Bank of America charges $30 for an international wire transfer for example. But it doesn’t stop there. The corresponding banks and the beneficiary’s bank might also charge unpredictable international wire receiving fees and the sending bank will probably give you an exchange rate that is less interesting than what you find on Google. There are better alternatives, Monito compares them all in real time. Compare now to find the best deal:</p>


   
        <h2 class="f_subtitle_1">You shouldn’t use PayPal and other digital wallets for international transfers</h2>
        <p class="f_body">Digital wallets have not only changed the way we pay for things on the Internet, but also how we send money to our friends and family. Specialized companies such as&nbsp;<a href="https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">PayPal</a>, <a href="https://transferwise.com/us/blog/square-cash-international-payment?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Square Cash</a>, Venmo or tech giants such as Google (with Google Wallet), Apple (with Apple Pay) and&nbsp;<a href="https://www.monito.com/en/wiki/facebook-finally-authorized-make-money-transfers-europe/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Facebook</a>&nbsp;(through Messenger), have revolutionized peer-to-peer payments, from the way &nbsp;we pay back a friend for a loan to how we split the bill at the end of a meal.</p><p class="f_body">
        The jury is still out when it comes to deciding which service is the best for your day-to-day needs, as it depends on a lot of factors including fees, limits, availability, and user experience. When it comes to <span class="fw-demi-bold">international money transfers</span> however, the answer is easy:  <span class="fw-demi-bold">none of them!</span></p>
        <p class="f_body">We can first easily exclude most of the contenders that are simply not offering international money transfers: <a href="https://transferwise.com/us/blog/square-cash-international-payment?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Square Cash App</a>, Venmo, Google Wallet, Apple Pay, <a href="https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Zelle </a>and Messenger. These don’t allow you to send money abroad. In addition, most of them are only available in the US and a few other countries.</p>
        <p class="f_body">Some digital wallets, namely PayPal or the Skrill Wallet (not to mistake with <a href="https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">Skrill money transfers</a>, which is a really interesting option), do give you the option of sending money between different countries and currencies (they even have an impressive number of supported currencies), and a lot of people are using them to send money abroad. But the convenience of these services comes at a <span class="fw-demi-bold">very high cost</span>.</p>
        <p class="f_body"><a href="https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">PayPal</a> may seem like good options for transferring money to a friend in another country or paying international freelancers for example, but due to a lot of different fees – most of them hidden – these transfers will cost you much more than if you used companies specializing exclusively in international money transfers.</p>
        <p class="f_body">We calculated that PayPal fees for international money transfers, which includes the transfer fee and the margin taken on the exchange rate, are between 3% and 10%. This means that sending $500 from the US to France might cost you as much as $50! TransferWise, the cheapest solution currently listed in <a href="https://www.monito.com/send-money/united-states/france/USD/EUR/500?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">our real-time comparison table</a> for this same transfer would cost only $5, or ten times less. </p> 
        <p class="f_body">So the next time you’re thinking about making an international transfer with <a href="https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">PayPal</a> or any other digital wallet, you’d be much better off making a quick comparison of your options on Monito and picking the current cheapest option.</p>
        <h2 class="f_subtitle_1">Digital wallet comparison for international money transfers</h2>
        <h3 class="f_chapo">Venmo</h3>
        <p class="f_body">Can you use Venmo for international transfers ? <span class="f_chapo">No</span></p>
        <p class="f_body">Countries where Venmo is available: <span class="f_chapo">US only</span></p>
        <h3 class="f_chapo">Square Cash App</h3>
        <p class="f_body">Can you use Square Cash for international transfers ? <span class="f_chapo">No</span></p>
        <p class="f_body">Countries where Square Cash is available: <span class="f_chapo">US only</span></p>
        <p class="f_body">Find out more about Square Cash App International <a href="https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">here.</a></p>
        <h3 class="f_chapo">Zelle</h3>
        <p class="f_body">Can you use Zelle for international transfers ? <span class="f_chapo">No</span></p>
        <p class="f_body">Countries where Zelle is available: <span class="f_chapo">US only</span></p>
        <p class="f_body">Find out more about Zelle <a href="https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content">here.</a></p>
        <h3 class="f_chapo">PayPal</h3>
        <p class="f_body">Can you use PayPal for international transfers ?  <span class="f_chapo">Yes</span></p>
        <p class="f_body">Countries where PayPal is available:  <span class="f_chapo">Almost everywhere (although money can’t be received or withdrawn in every country)</span></p>
        <p class="f_body">Total cost of an international money transfer:  <span class="f_chapo">Min 2.8% up to 10%</span></p>
    </section>

    <aside ref="scroll_widgets" class="scroller" ><monito-widgets-imt-search-form powered-by-nf="off" cta-label="Find alternatives to Venmo" country-from="US" country-to="MX"  utm-source="internal" utm-medium="internal"utm-content="main_content_widget" utm-campaign="ABTestVenmo"></monito-widgets-imt-search-form></aside>

   
  </main>
    
  <widget-faq>
    <h1 class="fs-28 fw-bold f-anti mb-9">Here are the most FAQs about Venmo</h1>
      <ul class="shadow">
        <li>
          <h3>Does Venmo work internationally? 🌎</h3>
          <p class="f_body">No, Venmo is only available for US residents sending money to other US residents in US Dollars. Use <a href="https://www.monito.com/en/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">Monito.com to compare and find cheap alternative services to send money abroad.</a></p>
        </li>
        <li>
          <h3>Does venmo work in Canada? Can canadians use Venmo? 🍁</h3>
          <p class="f_body">No, Venmo only work in the USA. You can find ways to <a href="https://www.monito.com/send-money/united-states/canada/usd/cad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">send money to Canada from the USA here.</a></p>
        </li>
        <li>
          <h3>What's the best way to send money abroad if Venmo is not available? 💸</h3>
          <p class="f_body">There are plenty of good options, as fancy and user friendly as Venmo, to send money abroad with a mobile phone. Use <a href="https://www.monito.com/en/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">Monito.com to compare and find cheap alternative services to send money abroad.</a></p>
        </li>
        <li>
          <h3>Does Venmo work in Mexico?</h3>
          <p class="f_body">No, Venmo is only available for US residents sending money to other US residents in US Dollars. You won't be able to use Venmo to send money to someone in Mexico from the US. But the good news is that there are dozens of good digital services for  <a href="https://www.monito.com/send-money-to/mexico?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">money transfers to Mexico</a> that you can compare on Monito.</p>
        </li>
        <li>
          <h3>What countries does Venmo work in?  Does venmo work in other contries?</h3>
          <p class="f_body">Venmo is only available in the US for US residents.</p>
        </li>
        <li>
          <h3>Does Venmo work in Nigeria?</h3>
          <p class="f_body">No, Venmo only work in the USA and for US residents. You can find & compare <a href="https://www.monito.com/send-money/united-states/nigeria/usd/ngn?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">money transfer services from the US to Nigeria here.</a></p>
        </li>
        <li>
          <h3>Does Venmo work in France?</h3>
          <p class="f_body">No, Venmo only work in the USA and for US residents. You can find & compare <a href="https://www.monito.com/send-money/united-states/france/usd/eur?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ">money transfer services from the US to France here.</a></p>
        </li>
      </ul>
  </widget-faq>
  <widget-articles :articles="articles"><h1 class="fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4">This might interest you too</h1></widget-articles>
  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
  	data() {
  		return {
  			herotype :'darkmode',
        heroForm : true,
        extForm : true,
        scrollingActive: true,
        sliderForm: false,
        urlBackground :'https://images.prismic.io/monito/9104871750b618a803702b821c687eea5f0c73c1_venmo-international-money-transfer.jpeg',
        providers : [
          { logo: 'public/review_ria.png',
            url:'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'5.8' },
          { logo: 'public/review_worldremit.png',
            url:'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.3' },
          { logo: 'public/review_paypal.png',
            url:'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'5.1' },
          { logo: 'public/review_remitly.png',
            url:'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'7.6'},
          { logo: 'public/review_transferwise.png',
            url:'https://www.monito.com/en/send-money-with/transferwise?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.8' },
          { logo: 'public/review_skrill.png',
            url:'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
            title:'Find the Cheapest Way to Send Money Abroad',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
            url:'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
            title:'Can I use Zelle to send money Internationally? No! Find alternatives now',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
            title:'Find the Fastest Way to Send Money Abroad',
            date_author:'Nov. 14, 2019'},

          
          { cover: 'https://www.monito.com/tawipages/images/prismic/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018  -  by Caroline Sieg'}
          
         

        ]
  		}
  	},
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,
      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.scroll_zone.clientHeight,
      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);
       var windows_width = window.innerWidth;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if(windows_width > 980){
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      if (this.scrollingActive == true){
        if(y > (position_x_aside - 20)){
          if(y <= (bottom_main_content - aside_height - 20)){
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '0px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '';
          this.$refs.scroll_widgets.style.position = 'relative';
          this.$refs.scroll_widgets.style.left = '';
      }
  
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">

  main {
    position: relative;
    z-index: 10000;
  }

  

  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
  }

  aside.mobile {
    display: none!important;
  }

  @media ($tablet_portrait) {
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      h1 {
        text-align: center;
      }
    }

    aside.mobile {
      display: block!important;
    }
    .scroller {
      width: 95%;
      margin-left: 2.5%;
      position: relative!important;
    }
  }


</style>


// WEBPACK FOOTER //
// src/components/Venmo.vue